import axios from "axios";
import authHeader from "./auth-header";
import apihostname from "./apihostname";

const instance = axios.create({
  baseURL: apihostname,
  headers: authHeader(),
});
// const head = { "Content-Type": "multipart/form-data" };

const instance2 = axios.create({
  baseURL: apihostname,
  headers: {
    ...authHeader(),
    ...{ "Content-Type": "application/x-www-form-urlencoded" },
  },
});

const instance3 = axios.create({
  baseURL: apihostname,
});
class RegsugarService {
  // newPass(id, req) {
  //   return instance.put("/users/new", req, {
  //     params: {
  //       id: id,
  //     },
  //   });
  // }
  //   updateUserprofile(id, req) {
  //     return instance.put("/users/profile/" + id, req);
  //   }
  //   getUserprofile(id) {
  //     return instance.get("/users/profile/" + id);
  //   }
  downloadPdf(id) {
    return instance.get("/download/" + id + ".pdf");
  }
  deleteRegsugar(id) {
    return instance.delete("/regsugar/" + id);
  }
  getRegsugarPrint(regsugar_id) {
    return instance.get("/regsugarcane-print/" + regsugar_id);
  }
  getRegsugarIsFarmer(person_card) {
    return instance.get("/regsugarcane-is-farmer/" + person_card);
  }
  updateStatus(body) {
    return instance.put("/regsugar/update-status", body);
  }
  getRegsugarlistAll() {
    return instance.get("/regsugar/list-all");
  }
  regsugarcaneSearth(body) {
    return instance.post("/regsugarcane-search", body);
  }
  getRegsugarlist(user_reg, timereg_id) {
    return instance.get("/regsugar/list/" + user_reg + "/" + timereg_id);
  }
  getRegsugarlistForRegistrar(user_reg, timereg_id) {
    return instance.get(
      "/regsugar/list-registrar/" + user_reg + "/" + timereg_id
    );
  }
  getRegsugarFrontPage(timereg_id) {
    return instance.get("/regsugar/frontpage/" + timereg_id);
  }
  getRegsugarcane(timereg_id) {
    return instance.get("/regsugarcane/" + timereg_id.toString());
  }
  createRegsugar(body) {
    return instance.post("/regsugar/new", body);
  }
  checkFarmer(body) {
    return instance.post("/regsugar/checkfarmer", body);
  }
  getMember(reg_id) {
    return instance.get("/reg_member/" + reg_id);
  }
  getDirect(reg_id) {
    return instance.get("/reg_direct/" + reg_id);
  }
  getMaster(reg_id) {
    return instance.get("/reg_master/" + reg_id);
  }
  getDeed(reg_id) {
    return instance.get("/reg_deed/" + reg_id);
  }
  updateRegsugar(body) {
    return instance.put("/regsugar", body);
  }
  approveStatusDOPA(body) {
    return instance.post("/approve_status_dopa", body);
  }
  approveStatusContract(body) {
    return instance.post("/approve_status_contract", body);
  }
  getMapDeed() {
    return instance.get("/sugarcane/map");
  }
  getSession() {
    return instance.get("/get-session");
  }
  setSession(body) {
    return instance2.post("/set-session", body);
  }
  checkRegsugarcane(idcard) {
    return instance3.get("/check-regsugarcane/" + idcard);
  }
  searchStatus(body) {
    return instance3.post("/search-status", body);
  }
}

export default new RegsugarService();
